import { getRequest, postRequest, putRequest } from "../apiConfig";

// Base route from backend
const SETTINGS = "/settings";

/* =========================
   ✅ ENTITIES API
========================= */
export const getEntities = () => getRequest(`${SETTINGS}/entities`);

export const addEntity = ({ country, name }) =>
  postRequest(`${SETTINGS}/entities`, { country, name });

export const updateEntity = (id, { country, name }) =>
  putRequest(`${SETTINGS}/entities/${id}`, { country, name });

/* =========================
   ✅ CATEGORIES API
========================= */
export const getCategories = () => getRequest(`${SETTINGS}/categories`);

export const addCategory = ({ country, name }) =>
  postRequest(`${SETTINGS}/categories`, { country, name });

export const updateCategory = (id, { country, name }) =>
  putRequest(`${SETTINGS}/categories/${id}`, { country, name });
